import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, HostBinding } from '@angular/core';

class ChipSetComponent {
    constructor() {
        this.classKbScrollbar = true;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.7", ngImport: i0, type: ChipSetComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.0.7", type: ChipSetComponent, isStandalone: true, selector: "kb-chip-set:not([type])", host: { properties: { "class.kb-scrollbar": "this.classKbScrollbar" } }, ngImport: i0, template: "<ng-content></ng-content>\n", styles: [":host{display:flex;align-items:flex-start;gap:var(--kb-gap--outer-column--related);margin-left:var(--kb-gap--outer-column);padding-bottom:var(--kb-gap--outer-column--related);overflow-x:auto;scroll-behavior:smooth}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.7", ngImport: i0, type: ChipSetComponent, decorators: [{
            type: Component,
            args: [{ selector: 'kb-chip-set:not([type])', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, imports: [], template: "<ng-content></ng-content>\n", styles: [":host{display:flex;align-items:flex-start;gap:var(--kb-gap--outer-column--related);margin-left:var(--kb-gap--outer-column);padding-bottom:var(--kb-gap--outer-column--related);overflow-x:auto;scroll-behavior:smooth}\n"] }]
        }], propDecorators: { classKbScrollbar: [{
                type: HostBinding,
                args: ['class.kb-scrollbar']
            }] } });

/**
 * Generated bundle index. Do not edit.
 */

export { ChipSetComponent };
